import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ProviderContainer from 'app/containers/InventoryManagement/OldInventory/Provider'

const ProviderContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <ProviderContainer />
    </>
  )
}
const ProviderContainerPage = memo(ProviderContainerPageCpn, isEqual)

export default ProviderContainerPage
